import * as gameSetupService from '@/services/game-setup.service';
import * as systemService from '@/services/system.service';

export async function startGame(gameId: string, adminUserId: string): Promise<void> {
  return gameSetupService.startGame(gameId, adminUserId);
}

export async function createGame(
  venue: string,
  date: string,
  time: string,
  venueAddress: string,
  adminUserId: string,
  invitedUserIds: string[]
): Promise<string> {
  return gameSetupService.createGame(venue, date, time, venueAddress, adminUserId, invitedUserIds);
}

export async function updatePlayerRSVP(
  gameId: string,
  playerIndex: number,
  rsvpStatus: 'yes' | 'no' | 'maybe'
): Promise<void> {
  return gameSetupService.updatePlayerRSVP(gameId, playerIndex, rsvpStatus);
}

export async function updateGameSetup(
  gameId: string,
  updates: { venue: string, date: string, time: string, venue_address: string }
): Promise<void> {
  return gameSetupService.updateGameSetup(gameId, updates);
}

export async function deleteGame(gameId: string, userId: string): Promise<void> {
  return systemService.deleteGame(gameId, userId);
}

export async function addPlayer(
  gameId: string,
  playerData: { user_id: string; name: string; email?: string }
): Promise<void> {
  return gameSetupService.addPlayer(gameId, playerData);
}
